//GeneratorFlag:[NoChange]
import DeliveryDateType from './delivery-date-type';

export default {DeliveryDateType}
export{DeliveryDateType}